import { render, staticRenderFns } from "./ModernNumberInput.vue?vue&type=template&id=591219f7&"
import script from "./ModernNumberInput.vue?vue&type=script&lang=js&"
export * from "./ModernNumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports